import { emitter } from 'lane-shared/helpers';

export async function emitAuthEventForAuth0(data: string) {
  emitter.emit((emitter as any).EVENT_AUTH_TOKEN, {
    authToken: data,
  });
}
